module.exports = __webpack_public_path__ + "img/sindrome_causas.f419eb38.jpg";